import { render, staticRenderFns } from "./CustomizedDiagram.vue?vue&type=template&id=38a60ffe&scoped=true&"
import script from "./CustomizedDiagram.vue?vue&type=script&lang=js&"
export * from "./CustomizedDiagram.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedDiagram.vue?vue&type=style&index=0&id=38a60ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a60ffe",
  null
  
)

export default component.exports